import { ToolbarMoveIcon } from '@editor/assets/icons'

import { BLUEPRINT_TOOL_LABELS } from '../../constants'
import { BlueprintEditorTool, BlueprintEditorTools, BlueprintToolbarCategory, Mode } from '../../definitions'

const Selector: BlueprintEditorTool = {
  key: BlueprintEditorTools.Selector,
  authCheck: () => true,
  toolbar: {
    icon: <ToolbarMoveIcon width="50%" height="50%" />,
    label: BLUEPRINT_TOOL_LABELS[BlueprintEditorTools.Selector],
    category: BlueprintToolbarCategory.Core,
    modes: [Mode.Editor2D],
  },
  hooks: {},
}

export default Selector
